import { render, staticRenderFns } from "./Step-3.vue?vue&type=template&id=0713c6a4&scoped=true&"
import script from "./Step-3.vue?vue&type=script&lang=js&"
export * from "./Step-3.vue?vue&type=script&lang=js&"
import style0 from "./Step-3.vue?vue&type=style&index=0&id=0713c6a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713c6a4",
  null
  
)

export default component.exports